<template>
	<div id="confirmpop">
    <span
      @click="showModal"
    >
    {{ text }}
    <i class="fa fa-plus"></i>
    </span>

    <ConfirmModal ref="confirmmodal"
      v-show="isModalVisible"
      v-bind:text="text"
      @close="closeModal"
    />
  </div>
</template>

<script>
import ConfirmModal from './components/confirm_modal.vue'

export default {
	components: {
    ConfirmModal,
	},
  props: ["text"],
  data() {
    return {
      isModalVisible: false,
    }
  },
  methods: {
    submit(){
      console.log(this);
    },
    showModal() {
     window.jQuery(this.$refs.confirmmodal.$el).modal('show')
     this.isModalVisible = true;
    },
    closeModal() {
     window.jQuery(this.$refs.confirmmodal.$el).modal('hide')
     this.isModalVisible = false;
     window.location.reload();
    },
  }
}
</script>

